import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

interface IStepProps {
  disabled?: boolean;
  onClick: () => void;
}

export const NextStepButton: React.FC<IStepProps> = ({ disabled, onClick }) => {
  return (
    <NextButton
      variant="primary"
      disabled={disabled}
      onClick={onClick}
      data-test-id="next-cta-button"
    >
      <StrictLocalMsg
        defaultMessage="Next"
        description={{ text: "CTA button to go to next step" }}
      />
    </NextButton>
  );
};

export const NeedMoreHelpButton: React.FC<IStepProps> = ({
  disabled,
  onClick,
}) => {
  return (
    <NextButton
      variant="secondary"
      disabled={disabled}
      onClick={onClick}
      data-test-id="need-more-help-cta-button"
    >
      <StrictLocalMsg
        defaultMessage="I Need More Help"
        description={{ text: "CTA button to go to need more help step" }}
      />
    </NextButton>
  );
};

export const SubmitButton: React.FC<IStepProps> = ({ disabled, onClick }) => {
  return (
    <NextButton variant="primary" disabled={disabled} onClick={onClick}>
      <StrictLocalMsg
        defaultMessage="Submit"
        description={{ text: "CTA button to submit your question" }}
      />
    </NextButton>
  );
};

export const CloseModalButton: React.FC<IStepProps> = ({ onClick }) => {
  return (
    <NextButton variant="primary" onClick={onClick}>
      <StrictLocalMsg
        defaultMessage="Close"
        description={{ text: "CTA button to close the modal" }}
      />
    </NextButton>
  );
};

const NextButton = styled(Button)`
  width: 100%;
  height: 50px;
`;
